import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import { Manager, Target, Popper } from 'react-popper';
import { ClickAwayListener } from 'material-ui';
import Grow from 'material-ui/transitions/Grow';
import Paper from 'material-ui/Paper';
import { MenuList } from 'material-ui/Menu';
import classes from './Menu.css';

const MenuListComposition = React.memo(({ renderTarget, children, id }) => {
    const [open, setOpen] = useState(false);

    const handleClose = useCallback(() => setOpen(false), []);

    const handleToggle = useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    return (
        <div className={classes.root}>
            <Manager>
                <Target>{renderTarget(open, handleToggle)}</Target>
                <Popper
                    placement={id && id === "logout" ? "bottom-end" : "bottom-start"}
                    eventsEnabled={open}
                    className={classNames({
                        [classes.popperClose]: !open,
                        [classes.open]: open
                    })}
                >
                    <ClickAwayListener onClickAway={handleClose}>
                        <Grow
                            in={open}
                            id="menu-list-grow"
                            style={{ transformOrigin: '0 0 0' }}
                        >
                            <Paper>
                                <MenuList role="menu" className={classes.menuList}>
                                    {open && children(handleToggle)}
                                </MenuList>
                            </Paper>
                        </Grow>
                    </ClickAwayListener>
                </Popper>
            </Manager>
        </div>
    );
});

export default MenuListComposition;
